import React from 'react';
const VideoEmbed = ({
  title = 'Embedded video',
  embedUrl,
  width = '916px',
  height = '515px'
}) => {
  return /*#__PURE__*/React.createElement("iframe", {
    width: width,
    height: height,
    src: embedUrl,
    title: title,
    style: {
      border: '0'
    },
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; fullscreen",
    referrerPolicy: "strict-origin-when-cross-origin",
    allowFullScreen: true
  });
};
export { VideoEmbed };